import { render, staticRenderFns } from "./copyHsctToHoct.vue?vue&type=template&id=3bc7bf57"
import script from "./copyHsctToHoct.vue?vue&type=script&lang=js"
export * from "./copyHsctToHoct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports